import { useI18n } from 'next-localization';

import { NeuButton } from '@hcahealthcaredpx/neutron-react';

export const NavigationButtons = ({
  isContinueDisabled,
  goToPreviousStep,
  isLastStep,
  continueButtonId,
}: {
  isContinueDisabled?: boolean;
  goToPreviousStep: () => void;
  isLastStep?: boolean;
  continueButtonId: string;
}): JSX.Element => {
  const { t } = useI18n();

  return (
    <div style={{ paddingTop: '40px', gap: '40px' }} className="d-flex justify-content-center">
      <NeuButton
        kind="tertiary"
        icon="arrow_back_ios"
        iconPosition="start"
        type="button"
        onNeuClick={goToPreviousStep}
      >
        {t('OAS.Booking.Navigation.Back')}
      </NeuButton>
      <NeuButton type="submit" disabled={isContinueDisabled} id={continueButtonId}>
        {isLastStep
          ? t('OAS.Profile.Details.BookAppointment')
          : t('OAS.Booking.Navigation.Continue')}
      </NeuButton>
    </div>
  );
};
